import script from "./Top20Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Top20Table.vue?vue&type=script&setup=true&lang=js"

import "./Top20Table.vue?vue&type=style&index=0&id=eab08510&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eab08510"]])

export default __exports__